import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AccountUsage } from "components/settings/account-usage";
import { Loading } from "components/common/loading";

const AccountUsagePage = (props) => {
  if (props.isLoading) {
    return <Loading />;
  }
  return (
    <AccountUsage { ...props } />
  );
};

AccountUsagePage.propTypes = {
  isLoading: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  isLoading: state.accountSettings.isLoading,
  planDetails: state.accountSettings.planDetails
});

export const AccountUsageContainer = connect(mapStateToProps)(AccountUsagePage);



// WEBPACK FOOTER //
// ./src/js/containers/settings/account-usage-container.jsx